exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.overlay[data-v-6b086c78] {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 2000;\n  transition: all 1300ms ease-in-out;\n  background: rgba(0, 0, 0, 0.5);\n}\n.overlay .promptHolder[data-v-6b086c78] {\n    background-color: #fff;\n    width: 550px;\n}\n.fade-enter-active[data-v-6b086c78], .fade-leave-active[data-v-6b086c78] {\n  transition: opacity .3s;\n}\n.fade-enter[data-v-6b086c78], .fade-leave-to[data-v-6b086c78] {\n  opacity: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6b086c78","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/richPrompt/richPrompt.vue
// module id = 2368
// module chunks = 0